import DocumentEditor from "@/components/DocumentEditor";
export default function QuotationEditor() {
  return <DocumentEditor kind="quotation" />;
}
